import Aux from "../../hoc/Auxiliary";
import ParticipantsSetting
    from "../../components/DataCollection/DataCollectionCreator/ParticipantsSetting/ParticipantsSetting";
import React, {useCallback, useEffect, useState} from "react";
import HeaderBreadCrumb, {normalizePathItem} from "../../components/BreadCrumb/Breadcrumb";
import DataCollectionDetails from "../../components/DataCollection/DataCollectionCreator/Details/DataCollectionDetails";
import Categories from "../../components/DataCollection/DataCollectionCreator/Categories/Categories";
import ActionList from "../../components/DataCollection/DataCollectionCreator/ActionsList/ActionsList";
import {
    deleteDataCollectionDraft,
    findDataCollectionById,
    getDataCollectionNames,
    getDCBDSFile,
    saveDataCollection,
    validateBoundaryPointFiles
} from "../../api/dataCollection/dataCollection-service";
import keycloak from "../../keycloak";
import Template from "../../components/DataCollection/DataCollectionCreator/Template/Template";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import LoadingScreen from "../LoadingScreen/LoadingScreen";
import {
    deleteDataCollectionFromLocalStorage,
    draftButtonIsDisable,
    emptyDataCollection,
    fetchDataCollectionConfigurations,
    getPermissionByParticipants,
    getSelectedParticipants,
    publishButtonIsDisable,
    selectedParticipantsHavePermissions,
    updateParticipantsPermission,
} from "../../api/dataCollection/dataCollection-utils";
import {
    loadFromSessionStorage,
    loadState,
    removeFromSessionStorage
} from "../../api/State/manage-state-storage-service";
import {updateProperty} from "../../api/utils/conditions-utils";
import classes from "../../components/DataCollection/DataCollectionCreator/Details/DataCollectionDetails.module.css";
import {Button} from "primereact/button";
import {Dialog} from "primereact/dialog";
import ExistingDataCollections
    from "../../components/DataCollection/DataCollectionCreator/DataCollectionToCopy/ExistingDataCollections";
import {showError, showInfo} from "../../api/notification/ToastManager";
import {NEW_DATA_COLLECTION_PATH} from "../../api/static-data/Configurations";
import {batchValidateCategory, findByDCAndMarketNode, validateCategory} from "../../api/Category/category-service";
import {getTags, saveFreeTag} from "../../api/dataCollection/tag-service";
import {DataCollectionType} from "../../enums/DataCollectionType";
import {getAllDataModelsWithStatusPublished} from "../../api/DataModel/data-model";

const DataCollectionBuilder = () => {
    const location = useLocation();
    const {dcName} = useParams();

    const navigate = useNavigate();
    const [scrollY, setScrollY] = useState(-1);
    const [display, setDisplay] = useState(false);
    const [participantsPermission, setParticipantsPermission] = useState({});
    const [dataCollection, setDataCollection] = useState({
        ...emptyDataCollection,
        createdBy: keycloak.idTokenParsed.name
    });
    const [pemmdbVersionNameList, setPemmdbVersionNameList] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [participants, setParticipants] = useState([]);
    const [selectedVersion, setSelectedVersion] = useState("");
    const [selectedParticipants, setSelectedParticipants] = useState([]);
    const [btnSaveLoading, setBtnSaveLoading] = useState({Draft: false, Published: false});
    const [btnPublishedIsDisable, setBtnPublishedIsDisable] = useState(true);
    const [btnDraftIsDisable, setBtnDraftIsDisable] = useState(true);
    const [indicationParticipantPermissions, setIndicationParticipantPermissions] = useState('');
    const [permissionsData, setPermissionsData] = useState([]);
    const [existingDataCollections, setExistingDataCollections] = useState([]);
    const [generalSettings, setGeneralSettings] = useState({});
    const [categoriesValid, setCategoriesValid] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [crumbItems, setCrumbItems] = useState(["Data Collections", "New"]);
    const [existingPublishedDCs] = useState([]);
    const [newPermission, setNewPermission] = useState({});
    const [participantsFromOtherDC, setParticipantsFromOtherDC] = useState(null);
    const [tags, setTags] = useState([]);
    const [isIGM, setIsIGM] = useState(false);
    const [BDSFiles, setBDSFiles] = useState({
        equipment: null,
        topology: null
    });
    const [BDSFilesValidationResult, setBDSFilesValidationResult] = useState({
        status: null,
        reportPath: null,
        isValidating: false
    })


    useEffect(() => {
        let selectedDataCollection = loadState(location?.state, "dataCollection");
        let screen = " ";
        let versionList = []
        if (location.pathname.endsWith(NEW_DATA_COLLECTION_PATH)) {
            screen = " 'Create new dataCollection' "
            removeFromSessionStorage("dataCollection");
            selectedDataCollection = null
        }
        getDataCollectionNames().then((res) => {
            setExistingDataCollections(res.filter(x => x !== selectedDataCollection?.name))
        })
        getAllDataModelsWithStatusPublished().then((res) => {
            setPemmdbVersionNameList(res)
            versionList = res
        })
        if (selectedDataCollection == null) {
            setIsLoading(false)
        }
        fetchDataCollectionConfigurations().then((data) => {
            try {
                setParticipants([...data.participants])
                setPermissionsData([...data.permissionsData])
                setTags(data.tags)
                if (selectedDataCollection) {
                    screen = " 'Edit dataCollection' "
                    setCrumbItems(["Data Collections", "Edit"]);
                    setIsEditMode(true);
                    setBDSFilesValidationResult({
                        status: true,
                        reportPath: null,
                        isValidating: false
                    });
                    searchTargetDataCollection(selectedDataCollection, versionList);
                    setIsLoading(false)
                }
            } catch (e) {
                showError("Error loading page", "An error occurs while displaying" + screen + "page")
                removeFromSessionStorage("dataCollection");
                navigate('/data_collections');
            }
        })

    }, [])

    useEffect(() => {
        if(!isIGM || normalizePathItem(dataCollection?.name) !== dcName){
            return;
        }
        const fetchFiles = async () => {
            const files = await getBDSFiles();
            setBDSFiles(files);
        };
        fetchFiles();
    }, [isIGM]);


    const handleScroll = useCallback(() => {
        if (Math.abs(window.scrollY - scrollY) > 100) {
            setScrollY(window.scrollY);
        }
    }, [scrollY])

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, [handleScroll]);

    const searchTargetDataCollection = (dataCollection, versionList) => {
        if (normalizePathItem(dataCollection?.name) === dcName) {
            findDataCollection(dataCollection, versionList)
        } else {
            setDataCollection({...emptyDataCollection, createdBy: keycloak.idTokenParsed.name})
            removeFromSessionStorage("dataCollection");
            navigate(NEW_DATA_COLLECTION_PATH);
        }
    }

    const findDataCollection = (dataCollection, versionList) => {
        findDataCollectionById(dataCollection?.id).then(d => {
            d.openFrom = new Date(d.openFrom);
            d.deadline = new Date(d.deadline);
            const version = versionList.find(x => x.id === d.model.id);
            setSelectedVersion(updateProperty(version !== undefined, version, ""));
            setSelectedParticipants(getSelectedParticipants(d.participants));
            setParticipantsPermission(getPermissionByParticipants(d.participants));
            setIsIGM(d.dataCollectionType?.code === "IGM")
            setDataCollection(d);
        })
    }

    const getBDSFiles = async () => {
        const [equipmentFile, topologyFile] = await Promise.all([
                getDCBDSFile(dataCollection?.id, "eq-"),
                getDCBDSFile(dataCollection?.id, "tp-")
        ]);

        return {
                equipment: equipmentFile,
                topology: topologyFile
            };

    }

    const saveAs = async (status, message) => {
        try {
            const payload = {
                status: status.toUpperCase(),
                dataCollection: dataCollection,
                successMsg: message,
                dataCollectionTypeCode: isIGM ? DataCollectionType.IGM : DataCollectionType.PEMMDB
            }
            const formData = new FormData();

            if (BDSFiles.equipment) {
                    formData.append('bdsFiles.equipment', BDSFiles.equipment);
                }

            if (BDSFiles.topology) {
                    formData.append('bdsFiles.topology', BDSFiles.topology);
            }

            setBtnSaveLoading({...btnSaveLoading, [status]: true})
            setIsLoading(true);
            const dc = loadFromSessionStorage("dataCollection");
            deleteDataCollectionFromLocalStorage(payload);
            formData.append('payload', JSON.stringify(payload));
            if (dc) {
                await deleteDataCollectionDraft({"dcId": dc?.id, "dcName": dc?.name});
            }
            await save(formData, status)
        } catch (e) {
            showError("Error", "An error occurs while saving dataCollection")
            removeFromSessionStorage("dataCollection");
            navigate('/data_collections');
        }
    }

    const handleIGMChange = (isChecked) => {
        setIsIGM(isChecked);
        setBDSFilesValidationResult({status: null, report: null})
        if (!isChecked) {
            setBDSFiles({equipment: null, topology: null});
        }
    };

    const validateBdsFile = () => {
        setBDSFilesValidationResult({...BDSFilesValidationResult, isValidating: true})
        const formData = new FormData();
        formData.append('modelName', dataCollection.model.name);

        if (BDSFiles.equipment) {
            formData.append('bdsFiles.equipment', BDSFiles.equipment);
        }

        if (BDSFiles.topology) {
            formData.append('bdsFiles.topology', BDSFiles.topology);
        }

        validateBoundaryPointFiles(formData)
            .then((response) => {
                setBDSFilesValidationResult({...response, isValidating: false})
            })
    }

    const handleBDSFileChange = (fileType, file,isNewFileSelected) => {
        setBDSFiles(prev => ({...prev, [fileType]: file}));
        if(isNewFileSelected){
            setBDSFilesValidationResult({status: null, reportPath: null, isValidating: false})
        }
    };

    async function validateAllData(res) {
        let distinctMarketNodes = [];
        res.content.participants.forEach(p => {
            if ((distinctMarketNodes.find(d => d.name === p.marketNode.name)) === undefined) {
                distinctMarketNodes.push(p.marketNode);
            }
        })
        for (var p of distinctMarketNodes) {
            await (findByDCAndMarketNode({id: res.content.id, name: res.content.name}, {id: p.id, name: p.name})
                .then(async r => {
                    if (r.status === 200) {
                        r.content.forEach((c) => {
                            if (c['filePath'] !== null) {
                                var data = {
                                    "modelPath": res.content.model.path,
                                    "categoryName": c['categoryDTO'].name,
                                    "dataCollection": {id: res.content.id, name: res.content.name},
                                    "marketNode": {id: p.id, name: p.name},
                                    "validationId": c['validationDTO'].id,
                                    "sheetsName": c['categoryDTO'].topics.map(s => s.name),
                                    "excelFilePath": c.filePath,
                                    "uploadMethod": c['categoryDTO'].uploadMethod.name
                                };
                                if (r.content.length > 1) {
                                    validateCategory(data)
                                } else {
                                    batchValidateCategory(data)
                                }

                            }

                        })
                    }
                }))
        }
    }

    const save = async (formData, status) => {
        const timeOut = setTimeout(() => {
            showInfo("Info", "Saving Data Collection might take several minutes")
            navigate("/data_collections/")
        }, 15000);
        const payload = JSON.parse(formData.get('payload'));
        payload.dataCollection.modifiedIn = updateProperty(status === "Draft", new Date(), payload.dataCollection.modifiedIn);
        payload.dataCollection.modifiedBy = updateProperty(status === "Draft", keycloak.idTokenParsed.name, payload.dataCollection.modifiedBy);
        saveDataCollection(formData).then(async res => {
                clearTimeout(timeOut)
                if (res.status === 200) {

                    if (payload.dataCollection?.copiedFrom?.reuseDataOption === "Reuse_data_and_revalidate_all_data") {
                        await validateAllData(res);
                    }
                    navigate("/data_collections/")
                } else {
                    setBtnSaveLoading({...btnSaveLoading, [status]: false})
                    setIsLoading(false);
                }
            }
        )
        ;
    }

    const onModelChange = (e) => {
        setBDSFilesValidationResult({
            status: null,
            reportPath: null,
            isValidating: false
        })
        var selectedModel = e.value
        if (selectedModel != null && selectedModel?.name !== dataCollection?.model.name) {
            let marketNodeList = selectedModel.marketNodes.map(x => x.name)
            Object.keys(participantsPermission).forEach(x => {
                const p = participantsPermission[x]
                permissionsData.forEach((y) => {
                    p[y.name] = p[y.name].filter(m => marketNodeList.includes(m.name))
                })
            })
            let topics = selectedModel.topics.map(x => x.name)
            dataCollection.categories.map(y => {
                y.topics = y.topics.filter(s => topics.includes(s.name))
                handleChange()
            })
        }
    }
    useEffect(() => {

        setParticipantsPermission(updateParticipantsPermission(selectedParticipants, participantsPermission))
    }, [selectedParticipants])

    useEffect(() => {
        const partPerm = selectedParticipantsHavePermissions(selectedParticipants, participantsPermission);
        setBtnPublishedIsDisable(!(partPerm && categoriesValid &&
            !publishButtonIsDisable(generalSettings, selectedParticipants, dataCollection.categories)))
        setBtnDraftIsDisable(draftButtonIsDisable(dataCollection.name, generalSettings))
        setIndicationParticipantPermissions(
            updateProperty(selectedParticipants.length === 0, 'Participant(s) should be selected',
                updateProperty(partPerm, "", "Missing one or more participant  permissions")));
    }, [dataCollection, participantsPermission, generalSettings, selectedParticipants, categoriesValid])

    const handleChange = (property, newValue) => {
        setDataCollection(prevState => ({...prevState, [property]: newValue}));
        if (property === 'model') {
            dataCollection.categories.forEach(c => {
                c.topics.forEach(s => {
                    let find = newValue.topics.find(
                        (elt) => elt.name === s.name);
                    s.id = find?.id
                    s.targetYearStart = find?.targetYearStart
                    s.targetYearEnd = find?.targetYearEnd
                    s.coordinationSubject = find?.coordinationSubject
                })
            })
        }
    }

    const handleSelectedTagsChange = (e) => {
        dataCollection.tags = e.target.value;
        setDataCollection(dataCollection);
    }
    useEffect(() => {
        if (participantsFromOtherDC) {

            handleChange("participants", participantsFromOtherDC)
            setParticipantsPermission(newPermission);
            setSelectedParticipants(getSelectedParticipants(participantsFromOtherDC));

        }
    }, [newPermission])
    const manageHideDialog = () => {
        setDisplay(false);
    }
    const abort = () => {
        navigate("/data_collections/")
    }
    const addTag = (newItem) => {
        saveFreeTag(newItem).then(res => {
            getTags().then(res => {
                if (res.status === 200) {
                    setTags(res.content);
                }
            })
        })
    }

    const hasZipXml = dataCollection?.categories?.some(
        (category) => category.uploadMethod?.name === "zip-xml"
    );

    return updateProperty(isLoading
        , (<LoadingScreen/>)
        , (<Aux>
            <Dialog header="Copy from another data collection" visible={display} style={{width: '60vw'}}
                    onHide={() => manageHideDialog()}>
                <ExistingDataCollections dcList={existingPublishedDCs}
                                         setBDSFiles={setBDSFiles}
                                         setSelectedPreviousDc={selectedParticipants}
                                         setParticipantsFromOtherDC={setParticipantsFromOtherDC}
                                         participants={participants}
                                         permissionsData={permissionsData}
                                         setNewPermission={setNewPermission}
                                         setIsIGM={setIsIGM}
                                         setBDSFilesValidationResult={setBDSFilesValidationResult}
                                         marketNodes={selectedVersion.marketNodes}
                                         setSelectedVersion={(vn) => setSelectedVersion(vn)}
                                         onChange={(p, v) => handleChange(p, v)}
                                         setDisplay={setDisplay}
                                         setDataCollection={setDataCollection}


                >
                </ExistingDataCollections>
            </Dialog>
            <HeaderBreadCrumb items={crumbItems}/>
            <div className={classes.container}>
                <h3>Setup new data collection</h3>
                <Button className={classes.btnStyle}
                        visible={!isEditMode}
                        label="Copy from another Data Collection" icon="pi pi-copy"
                        onClick={() => {
                            setDisplay(true)
                        }}
                />
            </div>
            <form>

                <DataCollectionDetails dataCollection={dataCollection}
                                       pemmdbVersionList={pemmdbVersionNameList}
                                       onChange={(p, v) => handleChange(p, v)}
                                       version={selectedVersion}
                                       setVersionName={(vn) => setSelectedVersion(vn)}
                                       existingDataCollections={existingDataCollections}
                                       setGeneralSettings={setGeneralSettings}
                                       onModelChange={onModelChange}
                                       scroll={scrollY}
                                       tags={tags.filter(tag => !tag.defaultTag)}
                                       addTag={addTag}
                                       onTagsChange={(e) => handleSelectedTagsChange(e)}
                                       selectedTags={dataCollection.tags}
                                       isIGM={isIGM}
                                       onIGMChange={handleIGMChange}
                                       onBDSFileChange={handleBDSFileChange}
                                       validateBdsFile={validateBdsFile}
                                       BDSFiles={BDSFiles}
                                       BDSFilesValidationResult={BDSFilesValidationResult}
                                       initBDSFiles={BDSFiles}
                />
                <Categories categoryList={dataCollection.categories}
                            modelTopic={dataCollection.model.topics}
                            tags={tags}
                            onChange={(p, v) => handleChange(p, v)}
                            setCategoriesValid={setCategoriesValid}
                            isEditMode={isEditMode}
                            addTag={addTag}
                />
                <ParticipantsSetting participants={participants}
                                     mailMessage={dataCollection.mailMessage}
                                     setParticipants={setParticipants}
                                     onChange={(p, v) => handleChange(p, v)}
                                     version={selectedVersion}
                                     selectedParticipants={selectedParticipants}
                                     setSelectedParticipants={(e) => setSelectedParticipants(e)}
                                     errorMsg={indicationParticipantPermissions}
                                     permissionsData={permissionsData}
                                     participantsPermission={participantsPermission}
                                     setParticipantsPermission={(e) => {
                                         setParticipantsPermission(e)
                                     }}
                                     setNewPermission={setNewPermission}
                                     setParticipantsFromOtherDC={setParticipantsFromOtherDC}
                                     marketNodes={selectedVersion.marketNodes}
                />


                {(!isIGM && !hasZipXml) && <Template dataCollection={dataCollection}
                                                     modelVersion={selectedVersion}
                                                     generalSettings={generalSettings}
                />}
                <ActionList
                    BDSFilesValidationResult={BDSFilesValidationResult}
                    isIGM={isIGM}
                    saveAsDraft={() => saveAs("Draft", " was saved as Draft")}
                    saveAsPublished={() => saveAs("Published", " was published")}
                    buttonsLoadingState={btnSaveLoading}
                    publishIsDisable={btnPublishedIsDisable}
                    draftIsDisable={btnDraftIsDisable}
                    abort={() => abort()}

                />
            </form>
        </Aux>))
}

export default DataCollectionBuilder;
